export enum TimeZoneEnum {
    Europe_Kaliningrad = 2,
    Europe_Moscow = 3,
    Europe_Samara = 4,
    Asia_Yekaterinburg = 5,
    Asia_Omsk = 6,
    Asia_Novosibirsk = 7,
    Asia_Krasnoyarsk = 8,
    Asia_Irkutsk = 9,
    Asia_Yakutsk = 10,
    Asia_Vladivostok = 11,
    Asia_Kamchatka = 12,
}

export const TIME_ZONE_EN: Record<TimeZoneEnum, string> = {
    [TimeZoneEnum.Europe_Kaliningrad]: 'Europe/Kaliningrad',
    [TimeZoneEnum.Europe_Moscow]: 'Europe/Moscow',
    [TimeZoneEnum.Europe_Samara]: 'Europe/Samara',
    [TimeZoneEnum.Asia_Yekaterinburg]: 'Asia/Yekaterinburg',
    [TimeZoneEnum.Asia_Omsk]: 'Asia/Omsk',
    [TimeZoneEnum.Asia_Novosibirsk]: 'Asia/Novosibirsk',
    [TimeZoneEnum.Asia_Krasnoyarsk]: 'Asia/Krasnoyarsk',
    [TimeZoneEnum.Asia_Irkutsk]: 'Asia/Irkutsk',
    [TimeZoneEnum.Asia_Yakutsk]: 'Asia/Yakutsk',
    [TimeZoneEnum.Asia_Vladivostok]: 'Asia/Vladivostok',
    [TimeZoneEnum.Asia_Kamchatka]: 'Asia/Kamchatka',
};

export const TIME_ZONE_RUS: Record<TimeZoneEnum, string> = {
    [TimeZoneEnum.Europe_Kaliningrad]: 'Калининград', // 2
    [TimeZoneEnum.Europe_Moscow]: 'Москва, Санкт-Петербург, Ростов-на-Дону', // 3
    [TimeZoneEnum.Europe_Samara]: 'Самара, Ижевск, Ульяновск', // 4
    [TimeZoneEnum.Asia_Yekaterinburg]: 'Екатеринбург, Челябинск, Пермь, Уфа', // 5
    [TimeZoneEnum.Asia_Omsk]: 'Омск', // 6
    [TimeZoneEnum.Asia_Novosibirsk]: 'Новосибирск, Томск, Барнаул, Кемерово, Красноярск, Норильск, Абакан', // 7
    [TimeZoneEnum.Asia_Krasnoyarsk]: 'Иркутск, Улан-Удэ', // 8
    [TimeZoneEnum.Asia_Irkutsk]: 'Якутск, Чита (часть регионов)', // 9
    [TimeZoneEnum.Asia_Yakutsk]: 'Владивосток, Хабаровск, Уссурийск', // 10
    [TimeZoneEnum.Asia_Vladivostok]: 'Магадан, Сахалин (Южно-Сахалинск)', // 11
    [TimeZoneEnum.Asia_Kamchatka]: 'Петропавловск-Камчатский, Анадырь', // 12
};
